import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { FailedSolutionsSection } from './components/FailedSolutionsSection';
import { TransformationSection } from './components/TransformationSection';
import { SolutionSection } from './components/SolutionSection';
import { ForYouSection } from './components/ForYouSection';
import { IncludesSection } from './components/IncludesSection';
import { CredibilitySection } from './components/CredibilitySection';
import { PricingCTA } from './components/PricingCTA';
import { FAQSection } from './components/FAQSection';
import { Footer } from './components/Footer';
declare global {
  interface Window {
    fbq: (...args: unknown[]) => void;
    _fbq: (...args: unknown[]) => void;
  }
}
function initMetaPixel() {
  if (window.fbq) return;
  const n: any = window.fbq = function (...args: unknown[]) {
    n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
  };
  if (!window._fbq) window._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [] as unknown[][];
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  const firstScript = document.getElementsByTagName('script')[0];
  firstScript?.parentNode?.insertBefore(script, firstScript);
}
export function App() {
  useEffect(() => {
    initMetaPixel();
    window.fbq('init', '2042623636583188');
    window.fbq('track', 'PageView');
  }, []);
  return <main className="min-h-screen w-full bg-[#FDF8F0] overflow-x-hidden" data-id="element-0">
      <HeroSection data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <FailedSolutionsSection data-id="element-3" />
      <TransformationSection data-id="element-4" />
      <SolutionSection data-id="element-5" />
      <ForYouSection data-id="element-6" />
      <IncludesSection data-id="element-7" />
      <CredibilitySection data-id="element-8" />
      <PricingCTA data-id="element-9" />
      <FAQSection data-id="element-10" />
      <Footer data-id="element-11" />
    </main>;
}